module.exports = "fonts/Twemoji_Mozilla/TwemojiMozilla-colr.9efd56e.woff2";